import React from 'react'
import PageTitle from '../../components/PageTitle'

const Verification = () => {
  return (
    <>
      <PageTitle title="Verification" />
      <section className="project-details pt-120 pb-70">
        <div className="container">
          <div className="row">
            <div className="col-xl-12 col-lg-12 mb-5 mb-lg-0">
              <div className="sec-title mb-40">
                <h6
                  className="sub-title wow fadeInUp bg-transparent ps-0"
                  data-wow-delay="00ms"
                  data-wow-duration="1500ms"
                >
                  About The Verification
                </h6>
                <h2 className="title mb-30 wow splt-txt" data-splitting>
                  Certificate Verification
                </h2>
                <p
                  className="text wow fadeInUp"
                  data-wow-delay="200ms"
                  data-wow-duration="1500ms"
                >
                  This page allows clients and stakeholders to securely verify
                  inspection, testing, calibration, and certification documents
                  issued by Pak Arab Inspection LTD. CO. By entering the certificate or
                  report number, users can instantly confirm the authenticity,
                  validity, and details of the issued document. Our verification
                  system is designed to ensure transparency, reliability, and
                  confidence in every service we provide.
                </p>
              </div>
            </div>
          </div>
          <div className="row g-4">
            <div
              className="col-md-6 col-xl-4 wow fadeInLeft"
              data-wow-delay="00ms"
              data-wow-duration="1500ms"
            >
              <div className="pricing-block">
                <div className="inner-box">
                  <div className="head">
                    <div className="icon">
                      <svg
                        width={55}
                        height={49}
                        viewBox="0 0 55 49"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M8.80043 1.91176C9.92321 -0.233244 12.9935 -0.233242 14.1162 1.91176L21.9931 16.9601C23.0387 18.9576 21.5898 21.3514 19.3352 21.3514H3.58144C1.32689 21.3514 -0.122003 18.9576 0.923544 16.9601L8.80043 1.91176Z"
                          fill="#1A4137"
                        />
                        <path
                          d="M40.8838 1.91176C42.0065 -0.233244 45.0768 -0.233242 46.1996 1.91176L54.0765 16.9601C55.122 18.9576 53.6731 21.3514 51.4186 21.3514H35.6648C33.4102 21.3514 31.9613 18.9576 33.0069 16.9601L40.8838 1.91176Z"
                          fill="#1A4137"
                        />
                        <path
                          d="M35.3769 48.1673C37.6314 48.1673 39.0803 45.7735 38.0348 43.776L30.1579 28.7277C29.0351 26.5827 25.9649 26.5827 24.8421 28.7277L16.9652 43.776C15.9197 45.7735 17.3685 48.1673 19.6231 48.1673H35.3769Z"
                          fill="#1A4137"
                        />
                        <path
                          d="M8.80043 43.0895C9.92321 45.2345 12.9935 45.2345 14.1162 43.0895L21.9931 28.0411C23.0387 26.0437 21.5898 23.6499 19.3352 23.6499H3.58144C1.32689 23.6499 -0.122003 26.0437 0.923544 28.0411L8.80043 43.0895Z"
                          fill="#1A4137"
                        />
                        <path
                          d="M51.4186 23.6499C53.6731 23.6499 55.122 26.0437 54.0765 28.0411L46.1996 43.0895C45.0768 45.2345 42.0065 45.2345 40.8838 43.0895L33.0069 28.0411C31.9613 26.0437 33.4102 23.6499 35.6648 23.6499H51.4186Z"
                          fill="#1A4137"
                        />
                      </svg>
                    </div>
                    <h4 className="title">ID Card Verification</h4>
                    <p className="sub-title">ID Card Online Verification</p>
                  </div>
                  <div className="text-center mt-40">
                    <a className="btn-one-rounded" href="/id-card">
                      Search Id Card
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="col-md-6 col-xl-4 wow fadeInLeft"
              data-wow-delay="200ms"
              data-wow-duration="1500ms"
            >
              <div className="pricing-block">
                <div className="inner-box">
                  <div className="head">
                    <div className="icon">
                      <svg
                        width={55}
                        height={49}
                        viewBox="0 0 55 49"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M8.80043 1.91176C9.92321 -0.233244 12.9935 -0.233242 14.1162 1.91176L21.9931 16.9601C23.0387 18.9576 21.5898 21.3514 19.3352 21.3514H3.58144C1.32689 21.3514 -0.122003 18.9576 0.923544 16.9601L8.80043 1.91176Z"
                          fill="#1A4137"
                        />
                        <path
                          d="M40.8838 1.91176C42.0065 -0.233244 45.0768 -0.233242 46.1996 1.91176L54.0765 16.9601C55.122 18.9576 53.6731 21.3514 51.4186 21.3514H35.6648C33.4102 21.3514 31.9613 18.9576 33.0069 16.9601L40.8838 1.91176Z"
                          fill="#1A4137"
                        />
                        <path
                          d="M35.3769 48.1673C37.6314 48.1673 39.0803 45.7735 38.0348 43.776L30.1579 28.7277C29.0351 26.5827 25.9649 26.5827 24.8421 28.7277L16.9652 43.776C15.9197 45.7735 17.3685 48.1673 19.6231 48.1673H35.3769Z"
                          fill="#1A4137"
                        />
                        <path
                          d="M8.80043 43.0895C9.92321 45.2345 12.9935 45.2345 14.1162 43.0895L21.9931 28.0411C23.0387 26.0437 21.5898 23.6499 19.3352 23.6499H3.58144C1.32689 23.6499 -0.122003 26.0437 0.923544 28.0411L8.80043 43.0895Z"
                          fill="#1A4137"
                        />
                        <path
                          d="M51.4186 23.6499C53.6731 23.6499 55.122 26.0437 54.0765 28.0411L46.1996 43.0895C45.0768 45.2345 42.0065 45.2345 40.8838 43.0895L33.0069 28.0411C31.9613 26.0437 33.4102 23.6499 35.6648 23.6499H51.4186Z"
                          fill="#1A4137"
                        />
                      </svg>
                    </div>
                    <h4 className="title">Equipment Certificate</h4>
                    <p className="sub-title">Verify the authenticity of equipment</p>
                  </div>
                  <div className="text-center mt-40">
                    <a className="btn-one-rounded" href="/equipment-certificate">
                      Equipment Certificate
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="col-md-6 col-xl-4 wow fadeInLeft"
              data-wow-delay="400ms"
              data-wow-duration="1500ms"
            >
              <div className="pricing-block">
                <div className="inner-box">
                  <div className="head">
                    <div className="icon">
                      <svg
                        width={55}
                        height={49}
                        viewBox="0 0 55 49"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M8.80043 1.91176C9.92321 -0.233244 12.9935 -0.233242 14.1162 1.91176L21.9931 16.9601C23.0387 18.9576 21.5898 21.3514 19.3352 21.3514H3.58144C1.32689 21.3514 -0.122003 18.9576 0.923544 16.9601L8.80043 1.91176Z"
                          fill="#1A4137"
                        />
                        <path
                          d="M40.8838 1.91176C42.0065 -0.233244 45.0768 -0.233242 46.1996 1.91176L54.0765 16.9601C55.122 18.9576 53.6731 21.3514 51.4186 21.3514H35.6648C33.4102 21.3514 31.9613 18.9576 33.0069 16.9601L40.8838 1.91176Z"
                          fill="#1A4137"
                        />
                        <path
                          d="M35.3769 48.1673C37.6314 48.1673 39.0803 45.7735 38.0348 43.776L30.1579 28.7277C29.0351 26.5827 25.9649 26.5827 24.8421 28.7277L16.9652 43.776C15.9197 45.7735 17.3685 48.1673 19.6231 48.1673H35.3769Z"
                          fill="#1A4137"
                        />
                        <path
                          d="M8.80043 43.0895C9.92321 45.2345 12.9935 45.2345 14.1162 43.0895L21.9931 28.0411C23.0387 26.0437 21.5898 23.6499 19.3352 23.6499H3.58144C1.32689 23.6499 -0.122003 26.0437 0.923544 28.0411L8.80043 43.0895Z"
                          fill="#1A4137"
                        />
                        <path
                          d="M51.4186 23.6499C53.6731 23.6499 55.122 26.0437 54.0765 28.0411L46.1996 43.0895C45.0768 45.2345 42.0065 45.2345 40.8838 43.0895L33.0069 28.0411C31.9613 26.0437 33.4102 23.6499 35.6648 23.6499H51.4186Z"
                          fill="#1A4137"
                        />
                      </svg>
                    </div>
                    <h4 className="title">Training Certificate</h4>
                    <p className="sub-title">Training Certificate Online Verification</p>
                  </div>
                  <div className="text-center mt-40">
                    <a className="btn-one-rounded" href="verification/search-training">
                      Training Certificate
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Verification